<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <form @submit.prevent="saveServiceCategory">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
                <div class="md:flex md:items-center md:justify-between">
                    <div class="flex-1 min-w-0">
                        <h1 class="py-0.5 text-2xl font-semibold text-gray-900">{{ $t('Create service component') }}</h1>
                    </div>
                </div>
            </div>
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="mt-6 shadow sm:rounded-sm">
                    <loading :status="loading"/>
                    <div class="bg-white md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
                        <div class="md:col-span-1">
                            <h3 class="text-lg font-medium leading-6 text-gray-900">{{ $t('Service component details') }}</h3>
                            <p class="mt-1 text-sm leading-5 text-gray-500">
                                {{ $t('Service category with name, short description and order.') }}
                            </p>
                        </div>
                        <div class="mt-5 md:mt-0 md:col-span-2">
                            <div class="grid grid-cols-1 gap-6">
                                <div>
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="name">{{ $t('Name') }}</label>
                                    <div class="mt-1 relative rounded shadow-sm">
                                        <input id="name" v-model="serviceCategory.name" class="form-input block w-full" required>
                                    </div>
                                </div>
                                <div>
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="value">{{ $t('Order') }}</label>
                                    <div class="mt-1 relative rounded shadow-sm">
                                        <input id="value" v-model.number="serviceCategory.value" class="form-input block w-full" min="1" required type="number">
                                    </div>
                                </div>
                                <div>
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="short_description">{{ $t('Short description') }}</label>
                                    <div class="mt-1 relative rounded shadow-sm">
                                        <textarea
                                            id="short_description"
                                            v-model="serviceCategory.short_description"
                                            class="form-textarea block w-full"
                                            maxlength="500"
                                            rows="3"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="stage-footer-surface text-right px-4 py-3 sm:px-6">
                        <div class="inline-flex">
                            <router-link class="btn btn-secondary shadow-sm rounded mr-4" to="/workspace/admin/settings/service-categories">
                                {{ $t('Cancel') }}
                            </router-link>
                            <button class="btn btn-gray shadow-sm rounded" type="submit">
                                {{ $t('Create service component') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </main>
</template>

<script>
export default {
    name: "service-categories-new",
    metaInfo() {
        return {
            title: this.$i18n.t('Create service component')
        }
    },
    data() {
        return {
            loading: false,
            serviceCategory: {
                name: null,
                short_description: null,
                value: 1,
            },
        }
    },
    methods: {
        saveServiceCategory() {
            const self = this;
            self.loading = true;
            axios.post('api/workspace/admin/service-categories', self.serviceCategory).then(function (response) {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data saved correctly').toString(),
                    type: 'success'
                });
                self.$router.push('/workspace/admin/settings/service-categories/' + response.data.serviceCategory.id + '/edit');
            }).catch(function () {
                self.loading = false;
            });
        },
    }
}
</script>
